module.exports = __webpack_public_path__ + "front/img/nav-bg.8d986bd8.png";